import React, { createContext, useContext } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = (props) => {

    const hasPermission = (requiredAllowedMenuIds = []) => {
        if (!requiredAllowedMenuIds.length) return true;
        return requiredAllowedMenuIds.every(perm => localStorage.getItem('allowedMenuIds')?.includes(perm));
    };

    const value = {
        hasPermission
    };

    return (
        <AuthContext.Provider value={value}>
            {props.children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);